import React from 'react';
import useDashboardApexChart from '../../hook/useDashboardApexChart';

const SalesProfit = ({ salesData }) => {

  const { createChartSix } = useDashboardApexChart();

  const sales = salesData?.sales?.salesProfit || {};

  const {
    totalPaid = 0,
    totalExpenses = 0,
    totalProfit = 0,
    trendPaid = [],
    trendExpenses = [],
    trendProfit = [],
    xAxisLabels = []
  } = sales;

  return (
    <div className="col-xxl-8">
      <div className="card radius-8 border-0 p-20">
        <div className="row gy-4">

          {/* TOTAL PAID */}
          <div className="col-xxl-3">
            <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-1 mb-12">
              <div className="card-body p-0">
                <div className="d-flex align-items-center gap-2 mb-12">
                  <span className="mb-0 w-48-px h-48-px bg-base text-pink text-2xl d-flex justify-content-center align-items-center rounded-circle h6">
                    <i className="ri-line-chart-fill" />
                  </span>
                  <span className="fw-medium text-secondary-light text-lg">
                    Sales
                  </span>
                </div>

                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="fw-semibold mb-0">${totalPaid}</h5>
                  {/* <p className="text-sm mb-0">
                    <span className="text-white px-1 rounded-2 fw-medium bg-success-main text-sm">
                      +${paidLast30}
                    </span>
                    This Month
                  </p> */}
                </div>
              </div>
            </div>

            {/* TOTAL EXPENSES */}
            <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-2 mb-12">
              <div className="card-body p-0">
                <div className="d-flex align-items-center gap-2 mb-12">
                  <span className="mb-0 w-48-px h-48-px bg-base text-purple text-2xl d-flex justify-content-center align-items-center rounded-circle h6">
                    <i className="ri-money-dollar-circle-fill" />
                  </span>
                  <span className="fw-medium text-secondary-light text-lg">
                    Expenses
                  </span>
                </div>

                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="fw-semibold mb-0">${totalExpenses}</h5>
                  {/* <p className="text-sm mb-0">
                    <span className="text-white px-1 rounded-2 fw-medium bg-success-main text-sm">
                      +${expensesLast30}
                    </span>
                    This Month
                  </p> */}
                </div>
              </div>
            </div>

            {/* TOTAL PROFIT */}
            <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-3 mb-0">
              <div className="card-body p-0">
                <div className="d-flex align-items-center gap-2 mb-12">
                  <span className="mb-0 w-48-px h-48-px bg-base text-info text-2xl d-flex justify-content-center align-items-center rounded-circle h6">

                    <i className="ri-funds-fill" />

                  </span>
                  <span className="fw-medium text-secondary-light text-lg">
                    Profit
                  </span>
                </div>

                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="fw-semibold mb-0">${totalProfit}</h5>
                  {/* <p className="text-sm mb-0">
                    <span className="text-white px-1 rounded-2 fw-medium bg-success-main text-sm">
                      +${profitLast30}
                    </span>
                    This Month
                  </p> */}
                </div>
              </div>
            </div>
          </div>

          {/* CHART */}
          <div className="col-xxl-9">
            <div className="card-body p-0">
              <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                <h6 className="mb-2 mt-1 fw-bold text-lg">Sales Trend</h6>
                {/* <div>
                  <select
                    className="form-select form-select-sm w-auto bg-base border text-secondary-light"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                  >
                    <option value="Yearly">Yearly</option>
                    <option value="Monthly">Monthly</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Today">Today</option>
                  </select>
                </div> */}
              </div>

              <ul className="d-flex justify-content-center mt-3 gap-3 stats-legend">
                <li className="d-flex align-items-center gap-2">
                  <span className="w-12-px h-12-px rounded-circle bg-primary-600" />
                  Sales<span className="legend-value">: <b>${totalPaid}</b></span>
                </li>

                <li className="d-flex align-items-center gap-2">
                  <span className="w-12-px h-12-px rounded-circle bg-danger" />
                  Expenses<span className="legend-value">: <b>${totalExpenses}</b></span>
                </li>

                <li className="d-flex align-items-center gap-2">
                  <span className="w-12-px h-12-px rounded-circle bg-success-main" />
                  Profits<span className="legend-value">: <b>${totalProfit}</b></span>
                </li>
              </ul>

              <div className="mt-40">
                <div id="enrollmentChart" className="apexcharts-tooltip-style-1">
                  {createChartSix('#487fff', '#ef4a00', '#45B369', trendPaid, trendExpenses, trendProfit, xAxisLabels)}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SalesProfit;
